module.exports = __webpack_public_path__ + "img/6_137.37935dca.png";